import plugin from 'tailwindcss/plugin';

const tag = plugin.withOptions(function () {
	return function ({ addComponents, theme, e }) {
		const white = theme('colors.white');
		const dark = theme('textColor.dark.primary');

		addComponents({
			[`.${e('tag')}`]: {
				alignItems: 'center',
				borderRadius: '100px',
				background: `var(--tag-background-color, ${theme('colors.black')})`,
				color: `var(--tag-front-color, ${white})`,
				display: 'flex',
				fontWeight: theme('fontWeight.semibold'),
				fontSize: theme('fontSize.xs'),
				gap: theme('spacing')['1.5'],
				letterSpacing: theme('letterSpacing.wider'),
				lineHeight: theme('lineHeight.3'),
				padding: `${theme('spacing.1')} ${theme('spacing')['1.5']}`,
				width: 'fit-content',

				[`@media (min-width: ${theme('screens.md')})`]: {
					fontSize: theme('fontSize.sm'),
					lineHeight: theme('lineHeight.4'),
					padding: `${theme('spacing')['1.5']} ${theme('spacing.3')}`,
				},
			},

			[`.${e('tag-border')}`]: {
				border: `1px solid var(--tag-front-color, ${white})`,
			},

			[`.${e('tag-black')}`]: {
				'--tag-front-color': `var(--tag-black-color-text, ${white})`,
				'--tag-background-color': `var(--tag-black-color-background, ${theme(
					'colors.black',
				)})`,
			},

			[`.${e('tag-dark-blue')}`]: {
				'--tag-front-color': `var(--tag-dark-blue-color-text, ${white})`,
				'--tag-background-color': `var(--tag-dark-blue-color-background, ${theme(
					'colors.info.100',
				)})`,
			},

			[`.${e('tag-blue')}`]: {
				'--tag-front-color': `var(--tag-blue-color-text,  ${dark})`,
				'--tag-background-color': `var(--tag-blue-color-background, ${theme(
					'colors.info.50',
				)})`,
			},

			[`.${e('tag-green')}`]: {
				'--tag-front-color': `var(--tag-green-color-text,  ${white})`,
				'--tag-background-color': `var(--tag-green-color-background, ${theme(
					'colors.success.125',
				)})`,
			},

			[`.${e('tag-light-green')}`]: {
				'--tag-front-color': `var(--tag-light-green-color-text,  ${dark})`,
				'--tag-background-color': `var(--tag-light-green-color-background, ${theme(
					'colors.success.50',
				)})`,
			},

			[`.${e('tag-light-lime')}`]: {
				'--tag-front-color': `var(--tag-light-lime-color-text,  ${dark})`,
				'--tag-background-color': `var(--tag-light-lime-color-background, ${theme(
					'colors.success.25',
				)})`,
			},

			[`.${e('tag-yellow')}`]: {
				'--tag-front-color': `var(--tag-yellow-color-text, ${dark})`,
				'--tag-background-color': `var(--tag-yellow-color-background, ${theme(
					'colors.warning.75',
				)})`,
			},

			[`.${e('tag-orange')}`]: {
				'--tag-front-color': `var(--tag-orange-color-text, ${dark})`,
				'--tag-background-color': `var(--tag-orange-color-background, ${theme(
					'colors.primary.75',
				)})`,
			},

			[`.${e('tag-magenta')}`]: {
				'--tag-front-color': `var(--tag-magenta-color-text, ${dark})`,
				'--tag-background-color': `var(--tag-magenta-color-background, ${theme(
					'colors.error.75',
				)})`,
			},

			[`.${e('tag-primary')}`]: {
				'--tag-front-color': `var(--tag-primary-color-text, ${theme('colors.primary.100')})`,
				'--tag-background-color': `var(--tag-primary-color-background, ${theme(
					'colors.primary.25',
				)})`,
			},

			[`.${e('tag-pink')}`]: {
				'--tag-front-color': `var(--tag-pink-color-text, ${dark})`,
				'--tag-background-color': `var(--tag-pink-color-background, #F4B6D5)`,
			},

			[`.${e('tag-dark-accent')}`]: {
				'--tag-front-color': `var(--tag-dark-accent-color-text, ${white})`,
				'--tag-background-color': `var(--tag-dark-accent-color-background, ${theme(
					'colors.accent.100',
				)})`,
			},

			[`.${e('tag-accent')}`]: {
				'--tag-front-color': `var(--tag-accent-color-text, ${theme(
					'colors.accent.150',
				)})`,
				'--tag-background-color': `var(--tag-accent-color-background, ${theme(
					'colors.accent.50',
				)})`,
			},
		});
	};
});

export default tag;
